import {
  React,
  Component
} from 'imports/CommonImports';

export default class NotFound extends Component {
  render() {
    return (
      <h1> Lo sentimos, esta página no existe </h1>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NotFound.js